var e = "Primary",
  o = "Select date range",
  n = "Select date",
  t = "YYYY-MM-DD",
  a = "Today",
  c = "Yesterday",
  _ = "This week",
  l = "Last 7 days",
  m = "Last 30 days",
  p = "Last week",
  r = "This month",
  i = "Last month",
  s = "This year",
  d = "Last year",
  b = "This date is invalid. Please try again.",
  L = "January",
  P = "February",
  y = "March",
  u = "April",
  k = "May",
  M = "June",
  F = "July",
  h = "August",
  g = "September",
  S = "October",
  T = "November",
  v = "December",
  f = "Mon",
  H = "Tue",
  x = "Wed",
  V = "Thu",
  C = "Fri",
  K = "Sat",
  D = "Sun",
  N = "Select all",
  E = "Select",
  B = "Showing",
  I = "out of",
  O = "Rows per page",
  Y = "{{x}} selected",
  w = "All selected",
  R = "Cancel",
  A = "Save",
  W = "Delete",
  J = "No matching search results.",
  U = "Search…",
  j = "Leave page? Changes you made may not be saved.",
  q = "This field cannot be empty.",
  z = "Something went wrong.",
  G = "Enter time",
  Q = "Enter time range",
  X = "HH:MM",
  Z = "HH:MM — HH:MM",
  $ = "HH:MM:SS",
  ee = "HH:MM:SS — HH:MM:SS",
  oe = "Enter name",
  ne = "Drop file to upload",
  te = "Drop file here or",
  ae = "Select...",
  ce = "browse",
  _e = "Loading",
  le = "Done",
  me = "Copy",
  pe = "Copied",
  re = "No results",
  ie = "Saved card",
  se = "Express checkout",
  de = "PayPal",
  be = "Enter number",
  Le = "Make primary",
  Pe = "Decline",
  ye = "Answer",
  ue = "Confirmed",
  ke = "Not confirmed",
  Me = "Add custom variable",
  Fe = "System variables",
  he = "Custom variables",
  ge = "Variables",
  Se = "Variable is invalid or does not exist.",
  Te = "Variable name",
  ve = "This variable already exists. Please try another.",
  fe = "Type",
  He = "String: up to 4096 characters",
  xe = "Number: up to 255 digits",
  Ve = "Datetime: in YYYY-MM-DD HH:MM:SS format",
  Ce = "String",
  Ke = "Number",
  De = "Datetime",
  Ne = "Add",
  Ee = {
    billing_paymentSettingsTab_savedCardsSection_primarySavedCardLabel: e,
    component_component_calendarPickerPromptLabel_datesFilterPrompt: o,
    component_component_calendarPickerPromptLabel_dateFilterPrompt: n,
    component_component_calendarPickerLabel_datesFilterDateRange: t,
    component_component_calendarPickerLabel_datesFilterToday: a,
    component_component_calendarPickerLabel_datesFilterYesterday: c,
    component_component_calendarPickerLabel_datesFilterThisWeek: _,
    component_component_calendarPickerLabel_datesFilterLast7Days: l,
    component_component_calendarPickerLabel_datesFilterLast30Days: m,
    component_component_calendarPickerLabel_datesFilterLastWeek: p,
    component_component_calendarPickerLabel_datesFilterThisMonth: r,
    component_component_calendarPickerLabel_datesFilterLastMonth: i,
    component_component_calendarPickerLabel_datesFilterThisYear: s,
    component_component_calendarPickerLabel_datesFilterLastYear: d,
    component_commonKeys_dateInvalidError: b,
    component_component_calendarPickerLabel_datesFilterJanuary: L,
    component_component_calendarPickerLabel_datesFilterFebruary: P,
    component_component_calendarPickerLabel_datesFilterMarch: y,
    component_component_calendarPickerLabel_datesFilterApril: u,
    component_component_calendarPickerLabel_datesFilterMay: k,
    component_component_calendarPickerLabel_datesFilterJune: M,
    component_component_calendarPickerLabel_datesFilterJuly: F,
    component_component_calendarPickerLabel_datesFilterAugust: h,
    component_component_calendarPickerLabel_datesFilterSeptember: g,
    component_component_calendarPickerLabel_datesFilterOctober: S,
    component_component_calendarPickerLabel_datesFilterNovember: T,
    component_component_calendarPickerLabel_datesFilterDecember: v,
    component_component_calendarPickerLabel_datesFilterMonday: f,
    component_component_calendarPickerLabel_datesFilterTuesday: H,
    component_component_calendarPickerLabel_datesFilterWednesday: x,
    component_component_calendarPickerLabel_datesFilterThursday: V,
    component_component_calendarPickerLabel_datesFilterFriday: C,
    component_component_calendarPickerLabel_datesFilterSaturday: K,
    component_component_calendarPickerLabel_datesFilterSunday: D,
    component_component_checkboxSelectOption_selectAllOption: N,
    component_component_checkboxSelectPromptLabel_selectLabel: E,
    component_component_paginatorInfoLabel_showing: B,
    component_component_paginatorInfoLabel_outOf: I,
    component_component_paginatorStepChangerLabel_perPageLabel: O,
    component_component_checkboxSelectLabel_selectedLabel: Y,
    component_component_checkboxSelectLabel_allSelectedLabel: w,
    component_commonKeys_cancelButton_cancelButton: R,
    component_commonKeys_saveButton_saveButton: A,
    component_commonKeys_deleteIcon_deleteIconButton: W,
    component_commonMessage_searchMessageLabel_noMatchingSearchMessageLabel: J,
    component_commonKeys_textPromptLabel_searchEllipsisPromptLabel: U,
    component_commonKeys_leavePagePrompt_leavePagePrompt: j,
    component_commonKeys_inputPromptLabel_fieldCannotBeEmptyError: q,
    component_notification_notificationLabel_somethingWentWrongLabel: z,
    component_component_timePickerPromptLabel_selectTime: G,
    component_component_timePickerPromptLabel_selectRangeTime: Q,
    component_component_timePickerPromptLabel_selectHHMM: X,
    component_component_timePickerPromptLabel_selectRangeHHMM: Z,
    component_component_timePickerPromptLabel_selectHHMMSS: $,
    component_component_timePickerPromptLabel_selectRangeHHMMSS: ee,
    component_enterTextField_textPromptLabel_enterNamePromptLabel: oe,
    component_fileUpload_uploadPrompt_dropFileToUploadLabel: ne,
    component_fileUpload_uploadPrompt_dropFileHereLabel: te,
    component_commonKeys_textPromptLabel_selectEllipsisPromptLabel: ae,
    component_commonKeys_buttonLabel_browseButton: ce,
    component_commonKeys_loadingLabel_loadingLabel: _e,
    component_commonKeys_doneLabel_doneLabel: le,
    component_component_copyLabel_copyTooltip: me,
    component_component_copiedLabel_copiedTooltip: pe,
    component_searchItemMenu_noSearchResults_noResultsLabel: re,
    component_component_paymentMethod_savedCardLabel: ie,
    component_component_paymentMethod_expressCheckoutLabel: se,
    component_component_paymentMethod_PayPalLabel: de,
    component_commonKeys_creditCardInformationPrompt_enterNumberLabel: be,
    component_commonKeys_selectTooltip_makePrimaryTooltip: Le,
    component_interactionNotification_buttonLabel_declineButtonLabel: Pe,
    component_interactionNotification_buttonLabel_answerButtonLabel: ye,
    component_component_input_emailConfirmed: ue,
    component_component_input_emailNotConfirmed: ke,
    component_component_popupMenu_addCustomVariableLabel: Me,
    component_component_popupMenu_systemVariablesLabel: Fe,
    component_component_popupMenu_customVariablesLabel: he,
    component_component_variableIcon_variableIconTooltipLabel: ge,
    component_component_variableError_invalidFormatLabel: Se,
    component_component_addVariableModal_variableNameLabel: Te,
    component_component_addVariableModal_variableExistsErrorLabel: ve,
    component_component_addVariableModal_typeLabel: fe,
    component_component_addVariableModal_typeTooltipStringText: He,
    component_component_addVariableModal_typeTooltipNumberText: xe,
    component_component_addVariableModal_typeTooltipDatetimeText: Ve,
    component_component_addVariableModal_typeStringOption: Ce,
    component_component_addVariableModal_typeNumberOption: Ke,
    component_component_addVariableModal_typeDatetimeOption: De,
    component_component_addVariableModal_addButtonLabel: Ne
  };
export { e as billing_paymentSettingsTab_savedCardsSection_primarySavedCardLabel, ce as component_commonKeys_buttonLabel_browseButton, R as component_commonKeys_cancelButton_cancelButton, be as component_commonKeys_creditCardInformationPrompt_enterNumberLabel, b as component_commonKeys_dateInvalidError, W as component_commonKeys_deleteIcon_deleteIconButton, le as component_commonKeys_doneLabel_doneLabel, q as component_commonKeys_inputPromptLabel_fieldCannotBeEmptyError, j as component_commonKeys_leavePagePrompt_leavePagePrompt, _e as component_commonKeys_loadingLabel_loadingLabel, A as component_commonKeys_saveButton_saveButton, Le as component_commonKeys_selectTooltip_makePrimaryTooltip, U as component_commonKeys_textPromptLabel_searchEllipsisPromptLabel, ae as component_commonKeys_textPromptLabel_selectEllipsisPromptLabel, J as component_commonMessage_searchMessageLabel_noMatchingSearchMessageLabel, Ne as component_component_addVariableModal_addButtonLabel, De as component_component_addVariableModal_typeDatetimeOption, fe as component_component_addVariableModal_typeLabel, Ke as component_component_addVariableModal_typeNumberOption, Ce as component_component_addVariableModal_typeStringOption, Ve as component_component_addVariableModal_typeTooltipDatetimeText, xe as component_component_addVariableModal_typeTooltipNumberText, He as component_component_addVariableModal_typeTooltipStringText, ve as component_component_addVariableModal_variableExistsErrorLabel, Te as component_component_addVariableModal_variableNameLabel, u as component_component_calendarPickerLabel_datesFilterApril, h as component_component_calendarPickerLabel_datesFilterAugust, t as component_component_calendarPickerLabel_datesFilterDateRange, v as component_component_calendarPickerLabel_datesFilterDecember, P as component_component_calendarPickerLabel_datesFilterFebruary, C as component_component_calendarPickerLabel_datesFilterFriday, L as component_component_calendarPickerLabel_datesFilterJanuary, F as component_component_calendarPickerLabel_datesFilterJuly, M as component_component_calendarPickerLabel_datesFilterJune, m as component_component_calendarPickerLabel_datesFilterLast30Days, l as component_component_calendarPickerLabel_datesFilterLast7Days, i as component_component_calendarPickerLabel_datesFilterLastMonth, p as component_component_calendarPickerLabel_datesFilterLastWeek, d as component_component_calendarPickerLabel_datesFilterLastYear, y as component_component_calendarPickerLabel_datesFilterMarch, k as component_component_calendarPickerLabel_datesFilterMay, f as component_component_calendarPickerLabel_datesFilterMonday, T as component_component_calendarPickerLabel_datesFilterNovember, S as component_component_calendarPickerLabel_datesFilterOctober, K as component_component_calendarPickerLabel_datesFilterSaturday, g as component_component_calendarPickerLabel_datesFilterSeptember, D as component_component_calendarPickerLabel_datesFilterSunday, r as component_component_calendarPickerLabel_datesFilterThisMonth, _ as component_component_calendarPickerLabel_datesFilterThisWeek, s as component_component_calendarPickerLabel_datesFilterThisYear, V as component_component_calendarPickerLabel_datesFilterThursday, a as component_component_calendarPickerLabel_datesFilterToday, H as component_component_calendarPickerLabel_datesFilterTuesday, x as component_component_calendarPickerLabel_datesFilterWednesday, c as component_component_calendarPickerLabel_datesFilterYesterday, n as component_component_calendarPickerPromptLabel_dateFilterPrompt, o as component_component_calendarPickerPromptLabel_datesFilterPrompt, w as component_component_checkboxSelectLabel_allSelectedLabel, Y as component_component_checkboxSelectLabel_selectedLabel, N as component_component_checkboxSelectOption_selectAllOption, E as component_component_checkboxSelectPromptLabel_selectLabel, pe as component_component_copiedLabel_copiedTooltip, me as component_component_copyLabel_copyTooltip, ue as component_component_input_emailConfirmed, ke as component_component_input_emailNotConfirmed, I as component_component_paginatorInfoLabel_outOf, B as component_component_paginatorInfoLabel_showing, O as component_component_paginatorStepChangerLabel_perPageLabel, de as component_component_paymentMethod_PayPalLabel, se as component_component_paymentMethod_expressCheckoutLabel, ie as component_component_paymentMethod_savedCardLabel, Me as component_component_popupMenu_addCustomVariableLabel, he as component_component_popupMenu_customVariablesLabel, Fe as component_component_popupMenu_systemVariablesLabel, X as component_component_timePickerPromptLabel_selectHHMM, $ as component_component_timePickerPromptLabel_selectHHMMSS, Z as component_component_timePickerPromptLabel_selectRangeHHMM, ee as component_component_timePickerPromptLabel_selectRangeHHMMSS, Q as component_component_timePickerPromptLabel_selectRangeTime, G as component_component_timePickerPromptLabel_selectTime, Se as component_component_variableError_invalidFormatLabel, ge as component_component_variableIcon_variableIconTooltipLabel, oe as component_enterTextField_textPromptLabel_enterNamePromptLabel, te as component_fileUpload_uploadPrompt_dropFileHereLabel, ne as component_fileUpload_uploadPrompt_dropFileToUploadLabel, ye as component_interactionNotification_buttonLabel_answerButtonLabel, Pe as component_interactionNotification_buttonLabel_declineButtonLabel, z as component_notification_notificationLabel_somethingWentWrongLabel, re as component_searchItemMenu_noSearchResults_noResultsLabel, Ee as default };